import { LoadingComponent, MasterPage } from "@components";
import { DadosPessoaisEntidade, EnderecoPessoaEntidade, EstadoCivilEntidade, GrauInstrucaoEntidade, ListaSexoEntidade, MunicipioEntidade, PessoaFisicaEntidade, UFEntidade } from "@entidades";
import { DateFix, getCEP } from "@helpers";
import { Alert, Box, Button, Col, ComboBox, Form, Input, Label, Row } from "@intech/web-ui";
import { DadosPessoaisService, EnderecoPessoaService, EstadoCivilService, GrauInstrucaoService, MunicipioService, PessoaFisicaService, SexoService } from "@services";
import React, { ReactNode, useEffect, useRef, useState } from "react";
import { FaSave } from "react-icons/fa";
import { useHistory } from "react-router-dom";
// import { toast, ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.min.css';

export const AlteracaoCadastral: React.FC = ({ ...rest }) => {
  const history = useHistory();

  const form = useRef<Form>(null);

  const [Dados, setDados] = useState<DadosPessoaisEntidade>(null);
  const [DadosSexo, setDadosSexo] = useState<ListaSexoEntidade[]>([]);
  const [DadosEstadoCivil, setDadosEstadoCivil] = useState<EstadoCivilEntidade[]>([]);
  const [DadosPessoaFisica, setDadosPessoaFisica] = useState<PessoaFisicaEntidade>(null);
  const [DadosEndereco, setDadosEndereco] = useState<EnderecoPessoaEntidade>(null);
  const [DadosMunicipio, setDadosMunicipio] = useState<MunicipioEntidade[]>([]);
  const [DadosGrauInstrucao, setDadosGrauInstrucao] = useState<GrauInstrucaoEntidade[]>([]);
  const [ListaUF, setListaUF] = useState<UFEntidade[]>([]);
  // const [DadosBancarios, setDadosBancarios] = useState<ContaBancariaEntidade>(null);
  const [Endereco, setEndereco] = useState<string>("");
  const [Numero, setNumero] = useState<string>("");
  const [Complemento, setComplemento] = useState<string>("");
  const [Bairro, setBairro] = useState<string>("");
  const [Cidade, setCidade] = useState<string>("");
  const [UF, setUF] = useState<string>("");
  const [Cep, setCep] = useState<string>("");
  const [Telefone, setTelefone] = useState<string>("");
  const [Celular, setCelular] = useState<string>("");
  const [Email, setEmail] = useState<string>("");

  const [Loading, setLoading] = useState<boolean>(true);
  const [Erro, setErro] = useState<ReactNode>("");
  const [FormErro, setFormErro] = useState<string>("");

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        await BuscarDados();
        await BuscarPessoaFisica();
        await BuscarEnderecoPessoa();
        await BuscarEstados();
        // await BuscarDadosBancarios();
      } catch (e) {
        const err: any = e;
        setErro(err.response ? err.response.data : err);
      }
      finally {
        setLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        if (UF) {
          const ListaMunicipio = await MunicipioService.BuscarListaMunicipioPorUF(UF);
          setDadosMunicipio(ListaMunicipio);
        }
      } catch (e) {
        const err: any = e;
        setErro(err.response ? err.response.data : err);
      }
    })();
  }, [UF]);

  async function BuscarDados() {
    const dados = await DadosPessoaisService.Buscar();
    const estadocivil = await EstadoCivilService.Buscar();
    const sexo = await SexoService.Buscar();
    const grauinstrucao = await GrauInstrucaoService.BuscarTodos();
    setDados(dados);
    setDadosEstadoCivil(estadocivil);
    setDadosSexo(sexo);
    setDadosGrauInstrucao(grauinstrucao);
  };

  async function BuscarPessoaFisica() {
    const pessoafisica = await PessoaFisicaService.Buscar();
    setDadosPessoaFisica(pessoafisica);
  };

  async function BuscarEnderecoPessoa() {
    const endereco = await EnderecoPessoaService.Buscar();
    setDadosEndereco(endereco);
    setCep(endereco.NR_CEP);
    setEndereco(endereco.DS_ENDERECO);
    setNumero(endereco.NR_ENDERECO);
    setComplemento(endereco.DS_COMPLEMENTO);
    setBairro(endereco.NO_BAIRRO);
    setCelular(endereco.NR_CELULAR);
    setTelefone(endereco.NR_FONE);
    setEmail(endereco.NO_EMAIL);
    setUF(endereco.CD_UF);
    setCidade(endereco.CD_MUNICIPIO);
  };

  async function BuscarEstados() {
    const listaUF = await MunicipioService.BuscarListaUF();
    setListaUF(listaUF);
  };

  // async function BuscarDadosBancarios () {
  //   const dadosbancarios = await ContaBancariaService.Buscar();
  //   setDadosBancarios(dadosbancarios);
  // };

  async function Validar() {
    setFormErro("");
    try {
      const erros = await form?.current?.validate();

      if (erros) {
        setErro(erros);
        return;
      }

      if (Cep.indexOf("_") > -1) {
        setErro("CEP Inválido.");
        setCep("")
        return;
      }

      await getCEP(Cep);

      Salvar();
    }
    catch (e) {
      const err: any = e;
      setFormErro(err.response ? err.response.data : err);
    }
  }

  async function Salvar() {
    try {
      const dadosEndereco = new EnderecoPessoaEntidade();
      dadosEndereco.DS_ENDERECO = Endereco;
      dadosEndereco.NR_ENDERECO = Numero;
      dadosEndereco.DS_COMPLEMENTO = Complemento;
      dadosEndereco.NO_BAIRRO = Bairro;
      dadosEndereco.CD_MUNICIPIO = Cidade;
      dadosEndereco.CD_UF = UF;
      dadosEndereco.NR_CEP = Cep;
      dadosEndereco.NR_FONE = Telefone;
      dadosEndereco.NR_CELULAR = Celular;
      dadosEndereco.NO_EMAIL = Email;

      // PessoaFisicaService.Atualizar(DadosPessoaFisica);
      const res = await EnderecoPessoaService.Atualizar(dadosEndereco);
      window.alert(res);
      history.push("dadosPessoais");
    }
    catch (e) {
      const err: any = e;
      setErro(err.response ? err.response.data : err);
    }
  }

  async function BuscarCep() {
    setFormErro("");
    try {

      if (Cep.indexOf("_") > -1) {
        setFormErro("CEP Inválido.");
        setCep("")
        return;
      }

      const cepres = await getCEP(Cep);

      setEndereco(cepres.logradouro || cepres.address);
      setComplemento(cepres.complemento || "");
      setBairro(cepres.bairro || cepres.district);
      // setCidade(cepres.localidade || cepres.city);
      setUF(cepres.uf || cepres.state);
    }
    catch (err) {
      setErro(err["response"] ? err["response"]["data"] : err);
      setCep("");
    }
  }

  return (
    <MasterPage {...rest}>
      {Loading && <LoadingComponent />}

      {!Loading && Erro && <Alert type={"danger"}>{Erro}</Alert>}

      {!Loading && !Erro && !Dados && <Alert type={"info"}>{"Nenhuma informação disponível no momento."}</Alert>}

      {!Loading && !Erro && Dados && <>
        <Form ref={form}>
          <Row>
            <Col className={"col-lg-12"}>
              <Box title={"Dados Pessoais"}>
                <Row>
                  <Col>
                    <Input
                      readonly
                      value={DadosPessoaFisica.NO_PESSOA}
                      title={"Nome"}
                      labelPosition={"up"}
                    />
                  </Col>

                  <Col>
                    <div className={"form-group"}>
                      <Label value={"Sexo"} labelPosition={"up"} required />

                      <ComboBox
                        disabled
                        value={DadosPessoaFisica.IR_SEXO}
                        defaultValue={DadosPessoaFisica.IR_SEXO}
                        data={DadosSexo}
                        memberName={"DS_SEXO"}
                        memberValue={"IR_SEXO"}
                        onChange={() => { }}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <div className={"form-group"}>
                      <Label value={"Estado Civil"} labelPosition={"up"} required />

                      <ComboBox
                        disabled
                        value={DadosPessoaFisica.CD_ESTADO_CIVIL}
                        defaultValue={DadosPessoaFisica.CD_ESTADO_CIVIL}
                        data={DadosEstadoCivil}
                        memberName={"DS_ESTADO_CIVIL"}
                        memberValue={"CD_ESTADO_CIVIL"}
                        onChange={() => { }}
                      />
                    </div>
                  </Col>

                  <Col>
                    <div className={"form-group"}>
                      <Label value={"Grau Instrução"} labelPosition={"up"} required />

                      <ComboBox
                        disabled
                        value={DadosPessoaFisica.CD_GRAU_INSTRUCAO}
                        data={DadosGrauInstrucao}
                        memberName={"DS_GRAU_INSTRUCAO"}
                        memberValue={"CD_GRAU_INSTRUCAO"}
                        onChange={() => { }}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Input
                      readonly
                      title={"DATA NASCIMENTO"}
                      value={DateFix(DadosPessoaFisica.DT_NASCIMENTO)}
                      labelPosition={"up"}
                    />
                  </Col>

                  <Col>
                    <Input
                      readonly
                      title={"CPF"}
                      value={DadosPessoaFisica.NR_CPF}
                      labelPosition={"up"}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Input
                      readonly
                      title={"NOME DO PAI"}
                      value={DadosPessoaFisica.NO_PAI}
                      labelPosition={"up"}
                    />
                  </Col>

                  <Col>
                    <Input
                      readonly
                      title={"NOME DA MÃE"}
                      value={DadosPessoaFisica.NO_MAE}
                      labelPosition={"up"}
                    />
                  </Col>
                </Row>
              </Box>
            </Col>
          </Row>

          <Row>
            <Col className={"col-lg-12"}>
              <Box title={"Endereço Residencial"}>
                <Row>
                  <Col>
                    <Input
                      required
                      title={"Cep"}
                      value={Cep}
                      labelPosition={"up"}
                      onChange={setCep}
                      group
                      buttonTitle={"Consultar"}
                      buttonType={"primary"}
                      onButtonClick={BuscarCep}
                    />
                  </Col>

                  <Col>
                    <Input
                      required
                      title={"Email"}
                      value={Email}
                      labelPosition={"up"}
                      onChange={setEmail}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Input
                      required
                      title={"Endereço"}
                      value={Endereco}
                      labelPosition={"up"}
                      onChange={setEndereco}
                    />
                  </Col>

                  <Col>
                    <Input
                      title={"Número"}
                      value={Numero}
                      labelPosition={"up"}
                      onChange={setNumero}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Input
                      title={"Complemento"}
                      value={Complemento}
                      labelPosition={"up"}
                      onChange={setComplemento}
                    />
                  </Col>

                  <Col>
                    <Input
                      required
                      title={"Bairro"}
                      value={Bairro}
                      labelPosition={"up"}
                      onChange={setBairro}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <div className={"form-group"}>
                      <Label value={"UF"} labelPosition={"up"} />

                      <ComboBox
                        required
                        value={UF}
                        data={ListaUF}
                        memberName={"DS_UF"}
                        memberValue={"CD_UF"}
                        onChange={setUF}
                      />
                    </div>
                  </Col>

                  <Col>
                    <div className={"form-group"}>
                      <Label value={"Cidade"} labelPosition={"up"} required />

                      <ComboBox
                        required
                        value={Cidade}
                        defaultValue={DadosEndereco.CD_MUNICIPIO}
                        data={DadosMunicipio}
                        memberName={"DS_MUNICIPIO"}
                        memberValue={"CD_MUNICIPIO"}
                        onChange={setCidade}
                      />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col>
                    <Input
                      title={"Fone"}
                      value={Telefone}
                      labelPosition={"up"}
                      onChange={setTelefone}
                    />

                  </Col>

                  <Col>
                    <Input
                      title={"Celular"}
                      value={Celular}
                      labelPosition={"up"}
                      onChange={setCelular}
                    />
                  </Col>
                </Row>
              </Box>
            </Col>
          </Row>


          <Alert type={"danger"} >{FormErro}</Alert>

          <Button icon={<FaSave />} onClick={Validar} title={"Salvar"} type={"primary"} loadingText={"Salvando..."} usesLoading submit />
        </Form>

      </>}

    </MasterPage>
  );

}
